import { useState, useEffect, useId } from 'react'

import Styles from './ThemeLoadingRow.module.scss'

const DEFAULT_LOADING_PHASES = [
  'Generating campaign theme...',
  'Reviewing your strategy...',
  'Analyzing topics...',
  'Proposing alternatives...',
]

const formatElapsedTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')} sec`
}

const SpinnerIcon = () => {
  const id = useId()
  const maskId = `${id}-mask`
  const gradientId = `${id}-gradient`
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={Styles.loadingSpinner}
    >
      <mask id={maskId} fill="white">
        <path d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z" />
      </mask>
      <path
        d="M14 7H11C11 9.20914 9.20914 11 7 11V14V17C12.5228 17 17 12.5228 17 7H14ZM7 14V11C4.79086 11 3 9.20914 3 7H0H-3C-3 12.5228 1.47715 17 7 17V14ZM0 7H3C3 4.79086 4.79086 3 7 3V0V-3C1.47715 -3 -3 1.47715 -3 7H0ZM7 0V3C9.20914 3 11 4.79086 11 7H14H17C17 1.47715 12.5228 -3 7 -3V0Z"
        mask={`url(#${maskId})`}
        style={{ fill: `url(#${gradientId})` }}
      />
      <defs>
        <linearGradient id={gradientId} x1="0" y1="7" x2="14" y2="7" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgba(65, 150, 253, 0)" />
          <stop offset="1" stopColor="rgba(65, 150, 253, 1)" />
        </linearGradient>
      </defs>
    </svg>
  )
}

interface ThemeLoadingRowProps {
  phases?: string[]
}

export const ThemeLoadingRow = ({ phases = DEFAULT_LOADING_PHASES }: ThemeLoadingRowProps) => {
  const [phaseIndex, setPhaseIndex] = useState(0)
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const phaseInterval = setInterval(() => {
      setPhaseIndex((prev) => (prev + 1) % phases.length)
    }, 3000)
    return () => clearInterval(phaseInterval)
  }, [phases.length])

  useEffect(() => {
    const timer = setInterval(() => {
      setElapsed((prev) => prev + 1)
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  return (
    <div className={Styles.loadingRow}>
      <SpinnerIcon />
      <span className={Styles.loadingTextGroup}>
        <span className={Styles.loadingText}>{phases[phaseIndex]}</span>
        <span className={Styles.loadingTimer}>{formatElapsedTime(elapsed)}</span>
      </span>
    </div>
  )
}
